var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";
import SetInitialPassword from '../../containers/SetInitialPassword/Set-initial-password';
import { Header } from '../Header/Header';
import { Footer } from '../Footer/Footer';
import SetLoginIdPassword from '../../containers/SetLoginIdPassword/Set-loginId-password';
var Routes = (function (_super) {
    __extends(Routes, _super);
    function Routes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Routes.prototype.render = function () {
        var _this = this;
        return (React.createElement(Router, null,
            React.createElement(Header, null),
            React.createElement("div", { className: "site-content", id: "main-content", role: "main" },
                React.createElement(Route, { exact: true, path: '/setPassword', component: function (props) {
                        return React.createElement(SetInitialPassword, __assign({}, props, _this.props));
                    } }),
                React.createElement(Route, { exact: true, path: '/setUsernamePassword', component: function (props) {
                        return React.createElement(SetLoginIdPassword, __assign({}, props, _this.props));
                    } })),
            React.createElement(Footer, null)));
    };
    return Routes;
}(React.Component));
export { Routes };
